import angular from 'angular';
import '../../services/organization-sla';
import '../../services/organization-segment';
import '../../services/errors';

const module = angular.module('whyline.modals.organization-sla', [
  'whyline.services.organization',
  'whyline.services.organization-sla',
  'whyline.services.errors',
]);

/**
 * It's the same modal as sla.js but it's used to show slas at organization level.
 *
 * @param $scope
 * @param $uibModalInstance
 * @param $translate
 * @param $timeout
 * @param NotificationService
 * @param OrganizationService
 * @param OrganizationSlaService
 * @param organizationSlaId
 * @param ErrorService
 * @param OrganizationSegmentService
 * @param dialog
 * @constructor
 */
const OrganizationSlaModalController = (
  $scope,
  $uibModalInstance,
  $translate,
  $timeout,
  NotificationService,
  OrganizationService,
  OrganizationSlaService,
  organizationSlaId,
  ErrorService,
  OrganizationSegmentService,
  dialog,
) => {
  'ngInject';

  const arrayRange = (start, stop, step) =>
    Array.from({ length: (stop - start) / step + 1 }, (value, index) => start + index * step);

  $scope.blockSaveButton = false;

  $scope.numbersSla = arrayRange(5, 100, 1);

  $scope.sla = {
    name: '',
    appointmentSla: '',
    prioritySla: '',
    spontaneousSla: '',
    isWhylineDefault: false,
    spontaneousTree: [],
  };

  $scope.organization = [];
  $scope.organization = OrganizationService.GetCurrent();

  const spontaneousTree = [];

  const init = async () => {
    if ($scope.organization.configuration.queuer.useSegments) {
      const segments = await OrganizationSegmentService.GetAllAsPromise();
      Object.values(segments).forEach((segment) => {
        const segmentSla = {
          _id: segment._id,
          name: segment.name,
          slaTime: '5',
        };

        spontaneousTree.push(segmentSla);
      });
    }

    if (organizationSlaId) {
      OrganizationSlaService.GetOneAsPromiseFromServer(organizationSlaId)
        .then((slaOrganizationDB) => {
          $timeout(() => {
            const slaOrganization = OrganizationSlaService.Copy(slaOrganizationDB);

            const spontaneousTreeArr = spontaneousTree.map((segment) => {
              const segmentSla = slaOrganization.spontaneousTree.find(
                (segmentSlaOrg) => segmentSlaOrg._id === segment._id,
              );
              if (segmentSla) {
                segment.slaTime = segmentSla.slaTime.toString();
              }
              return segment;
            });

            $scope.sla._id = slaOrganization._id;
            $scope.sla.name = slaOrganization.name;
            $scope.sla.appointmentSla = slaOrganization.appointmentSla.toString();
            $scope.sla.prioritySla = slaOrganization.prioritySla.toString();
            $scope.sla.spontaneousSla = slaOrganization.spontaneousSla.toString();
            $scope.sla.spontaneousTree = spontaneousTreeArr;
            $scope.sla.isWhylineDefault = slaOrganization.isWhylineDefault;
          });
        })
        .catch(ErrorService.handler);
    } else {
      $timeout(() => {
        $scope.sla.spontaneousTree = spontaneousTree;
        $scope.sla.appointmentSla = '5';
        $scope.sla.prioritySla = '5';
        $scope.sla.spontaneousSla = '5';
      });
    }
  };

  const validate = () => {
    if (!$scope.sla.name) {
      NotificationService.Warning($translate.instant('sla_name_required'));
      return false;
    }

    if (!/^[ '-:A-Za-z\xC0-\xCF\xD1-\xD6\xD8-\xDD\xDF-\xE5\xE7-\xF6\xF8-\xFD\xFF\u0104-\u0107\u010C\u010D\u0116-\u0119\u012E\u012F\u0141-\u0144\u0152\u0160\u0161\u016A\u016B\u0172\u0173\u0178-\u017E]+$/.test($scope.sla.name)) {
      NotificationService.Warning($translate.instant('char_forbidden_name'));
      return false;
    }

    // if ($scope.sla.name.length > 56) {
    //   NotificationService.Warning($translate.instant('sla_name_max_length'));
    //   return false;
    // }

    return true;
  };

  $scope.close = () => {
    $uibModalInstance.close('cancel');
  };

  $scope.save = () => {
    if (validate()) {
      const { name } = $scope.sla;
      $scope.blockSaveButton = true;
      let message = '';
      let promise = null;
      if (organizationSlaId) {
        message = $translate.instant('sla_update_succ');
        promise = OrganizationSlaService.Update($scope.sla);
        NotificationService.Warning('sla_edit_warning');
      } else {
        message = $translate.instant('sla_create_succ');
        promise = OrganizationSlaService.Create($scope.sla);
      }

      promise.then(() => {
        NotificationService.Success(message.replace('{name}', name));

        $uibModalInstance.close('cancel');
      });

      return promise.catch((err) => {
        $scope.blockSaveButton = false;

        if (err && err.status === 406) {
          const { data: reason } = err;

          const errMessage = $translate.instant(reason);

          NotificationService.Warning(errMessage);
        } else {
          ErrorService.handler(err);
        }
      });
    }
  };

  init();
};

module.exports = module.controller(
  'OrganizationSlaModalController',
  OrganizationSlaModalController,
);
